import { createAsyncThunk } from "@reduxjs/toolkit";
import authService from "../../../api/services/auth";

export const login = createAsyncThunk("auth/login", async (requestData) => {
  return await authService.login(requestData);
});

export const refresh = createAsyncThunk("auth/refresh", async () => {
  return await authService.refresh();
});

export const logout = createAsyncThunk("auth/logout", async (_, thunkAPI) => {
  thunkAPI.dispatch({ type: "logout" });
  // thunkAPI.dispatch({ type: "reset" });
  return await authService.logout();
});
